import styled from "styled-components";

export const StyledCmSheetFooterLeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
`;
